import WebsiteBehaviors from "../website-behaviors/index.js";
import Citation from "../citation.js";
import {waitUntil} from "../utils/async.js";

/**
 * An example of the html viewer is here:
 * https://proxy.library.upenn.edu/login?url=https://search.ebscohost.com/login.aspx?direct=true&db=aph&AN=9111041886&site=ehost-live
 */
class EbscoHtml extends WebsiteBehaviors {
	identifier() {
		return "EbscoHtml";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return /^(web|eds)\.[^\.]+\.ebscohost\.com$/.test(location.host);
	}

	async getPermalink() {
		// First need to click on the permalink button to enable whatever updates the permalink
		const event = new MouseEvent("click", {
			view:       window,
			bubbles:    true,
			cancelable: true
		});
		// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
		document.querySelector("a.permalink-link").dispatchEvent(event);

		// Now wait for the link to show up
		const stopCondition = () => {
			const plink = document.getElementById("pLinkDetail");
			return (plink !== null && (plink as any).value !== "");
		};

		try {
			await waitUntil(stopCondition);

			// Close the toolbar; the permalink element remains in the dom and is updated as the user navigates.
			// @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
			document.getElementById("ToolPanelContent").querySelector(".close-panel").dispatchEvent(event);
		} catch (e) {
			// Just move on
			console.error("PN: Gave up waiting for permalink", e);
		}
	}

	destroy() {
		if (!(this as any).initialized)
			return;
		(this as any).initialized = false;

		super.destroy();
	}

	async init() {
		if ((this as any).initialized)
			return;
		(this as any).initialized = true;

		await super.init();

		await new Promise(r => setTimeout(r, 1000)); // Wait a bit or the "permalink" functionality won't work.

		await this.getPermalink();
		const plinkElement = document.getElementById("pLinkDetail");
		if (plinkElement) {
			const pageUrl = (plinkElement as any).value;
			document.documentElement.setAttribute("data-pn-url", pageUrl);
			// @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
			document.documentElement.setAttribute("data-pn-url-final", 1); // Don't let processOrgProxy rewrite the URL (we trust the permalink given by Ebsco).
		}
	}

	// @ts-expect-error FIXME
	async generateStructuredCitation(url, getEbscoCitationRis) {
		// Get an and dbid from url hash
		const urlHash = window.location.hash.substring(1); // remove # from string
		const params = new URLSearchParams(urlHash);
		const an = params.get("AN");
		const dbid = params.get("db");
		let ris;

		try {
			ris = await getEbscoCitationRis(an, dbid);
		} catch (e) {
			const edsNotConfiguredCode = 5005;
			const edsErrorCode = 5003;

			if (e.apiCode === edsNotConfiguredCode || e.apiCode === edsErrorCode) {
				// Download the RIS that you would get from clicking Export on
				// the page, choosing "Direct Export in RIS Format", and
				// clicking Save

				// Ex. https://web-s-ebscohost-com.proxy.library.upenn.edu/ehost/delivery/ExportPanelSave/YXBoX18xNTgyMjAyOTFfX0FO0?vid=0&sid=4213ad3c-e77e-471a-9cd1-64383248951a%40redis&bdata=JnNpdGU9ZWhvc3QtbGl2ZQ%3d%3d&theExportFormat=1
				// @ts-expect-error
				const searchString = document.getElementById("aspnetForm").getAttribute("action").replace("detail?", "");

				// Get the "YXBoX18xNTgyMjAyOTFfX0FO0" part in the example url above
				const normalStr = `${dbid}__${an}__AN`;
				const base64encodedStr = btoa(normalStr) + "0";

				// Build the download URL
				const downloadUrl = `${window.location.origin}/ehost/delivery/ExportPanelSave/${base64encodedStr}?${searchString}&theExportFormat=1`;

				// Get the RIS download
				const result = await fetch(downloadUrl, {"method": "GET"});
				ris = await result.text();
			} else
				throw new Error("PN: EBSCO Citation gathering failed: " + e);
		}
		return Citation.fromRIS(ris);
	}
}

export default EbscoHtml;
